var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"clear":"both","width":"100%","min-height":"81px"}},[_c('div',{staticClass:"w3-hide-small"},[_c('Desktop')],1),_vm._v(" "),_c('div',{staticClass:"w3-hide-medium w3-hide-large"},[_c('Mobile')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }